module.exports = __webpack_public_path__ + "static/img/activity-20230509.4d9299d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-20230509.png
// module id = 0a+v
// module chunks = 0